import About from "@/components/site/About";

export default function AboutPage() {
  return <About />;
}
